/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _browser = __webpack_require__(2);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	var _btnhumberger = __webpack_require__(5);
	
	var _btnhumberger2 = _interopRequireDefault(_btnhumberger);
	
	var _gnav = __webpack_require__(19);
	
	var _gnav2 = _interopRequireDefault(_gnav);
	
	var _btnpagetop = __webpack_require__(7);
	
	var _btnpagetop2 = _interopRequireDefault(_btnpagetop);
	
	var _btntab = __webpack_require__(8);
	
	var _btntab2 = _interopRequireDefault(_btntab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	window.onload = function () {
		new Spot();
	};
	
	var Spot = function () {
		function Spot() {
			_classCallCheck(this, Spot);
	
			//Gnav
			this.gnav = new _gnav2.default($('#Gnav'));
	
			//BtnHamburger
			this.btnHamburger = new _btnhumberger2.default($('#BtnHamburger'));
	
			//PageTop
			this.btnPageTop = new _btnpagetop2.default($('#BtnPageTop'));
	
			this.btnSanpoBottom = new _btntab2.default($('#BtnSanpoBottom'));
	
			$('#Header .menu a').on('click', function (e) {
				var $target = $(e.currentTarget);
				var hash = $target.attr('href');
				$(hash).velocity('scroll', { duration: 500, easing: "easeInOutQuad", delay: 0 });
				return false;
			});
	
			this.initEvent();
		}
	
		_createClass(Spot, [{
			key: 'initEvent',
			value: function initEvent() {
				var _this = this;
	
				/*
	   		let tabChangeFunc = (e)=>{
	   			if( e.$con.attr('id') == 'BtnSanpoBottom' || e.$con.attr('id') == 'BtnZoomBottom' ){
	   				this.tabChange(e.$con.data('id'),false,600);
	   			} else {
	   				this.tabChange(e.$con.data('id'),false,300);
	   			}
	   		};
	   		this.btnSanpo.on('click' , tabChangeFunc);
	   		this.btnZoom.on('click' , tabChangeFunc);
	   		this.btnZoomBottom.on('click' , tabChangeFunc);
	   		this.btnSanpoBottom.on('click' , tabChangeFunc);
	   		$('#BtnSanpoFooter').on('click' , ()=>{ this.tabChange( 'TabSanpo',true,500); });
	   		$('#BtnZoomFooter').on('click' , ()=>{ this.tabChange( 'TabZoom',true,500); });
	   */
	
				var navToggleFunc = function navToggleFunc() {
					if (_this.gnav.isOpen) {
						_this.gnav.close();
						_this.btnHamburger.close();
					} else {
						_this.gnav.open();
						_this.btnHamburger.open();
					}
				};
				this.btnHamburger.on('click', navToggleFunc);
				this.gnav.on('nav_click', function (id) {
					//navToggleFunc();
					//this.tabChange(id,false,1);
				});
			}
		}]);

		return Spot;
	}();

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Browser = function () {
		function Browser() {
			_classCallCheck(this, Browser);
	
			this.SP_MAX_WIDTH = 768;
			this.TB_MIN_WIDTH = 769;
			this.TB_MAX_WIDTH = 999;
	
			this.isIE = false;
			this.isIE6 = false;
			this.isIE7 = false;
			this.isIE8 = false;
			this.isIE9 = false;
			this.isFF = false;
			this.isFF35 = false;
			this.isOpera = false;
			this.isChrome = false;
			this.isSafari = false;
			this.isiPhone = false;
			this.isiPad = false;
			this.isiPod = false;
			this.isAndroid = false;
	
			this.isCanvas = false;
			this.isTransform = false;
			this.isTransition = false;
			this.isSp = false;
			this.isTouch = 'ontouchstart' in window;
	
			this.isWindows = false;
			this.isMac = false;
	
			this.scrollX = 0;
			this.scrollY = 0;
			this.scrollYPercent = 0;
			this.windowWidth = 0;
			this.windowHeight = 0;
			this.windowWidthHalf = 0;
			this.windowHeightHalf = 0;
			this.documentWidth = 0;
			this.documentHeight = 0;
			this.scrollRate = 0;
	
			this.resizeFunction = [];
			this.responsiveFunction = [];
			this.responsivePCSPFunction = [];
			this.scrollFunction = [];
			this.requestAnimationFrameFunction = [];
	
			this.responsive = 'pc';
			this.responsivePCSP = 'pc';
			this.transitionend = 'oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend';
			this.animationend = 'webkitAnimationEnd animationend';
			this.scrollEvent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
	
			this.webgl = function () {
				try {
					var canvas = document.createElement('canvas');
					return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
				} catch (e) {
					return false;
				}
			}();
	
			this.initUA();
	
			window.addEventListener('scroll', this._scrollHandler.bind(this), false);
			this._scrollHandler();
	
			window.addEventListener('resize', this._resizeHandler.bind(this), false);
			this._resizeHandler();
		}
	
		//----------------------------------------
		//PUBLIC METHOD
		//----------------------------------------
	
	
		_createClass(Browser, [{
			key: 'initUA',
			value: function initUA() {
				var userAgent = window.navigator.userAgent.toLowerCase();
				var appVersion = window.navigator.appVersion.toLowerCase();
	
				if (userAgent.indexOf("msie") > -1) {
					this.isIE = true;
					if (appVersion.indexOf("msie 6.0") > -1) {
						this.isIE6 = true;
					} else if (appVersion.indexOf("msie 7.0") > -1) {
						this.isIE7 = true;
					} else if (appVersion.indexOf("msie 8.0") > -1) {
						this.isIE8 = true;
					} else if (appVersion.indexOf("msie 9.0") > -1) {
						this.isIE9 = true;
					}
				} else if (userAgent.indexOf("trident") > -1) {
					this.isIE = true;
				} else if (userAgent.indexOf("firefox") > -1) {
					this.isFF = true;
					var version = parseFloat(userAgent.match(/firefox\/(\d+\.\d+)/)[1]);
					this.isFF35 = version >= 3.5;
				} else if (userAgent.indexOf("iphone") > -1) {
					this.isiPhone = true;
				} else if (userAgent.indexOf("ipod") > -1) {
					this.isiPod = true;
				} else if (userAgent.indexOf("ipad") > -1) {
					this.isiPad = true;
				} else if (userAgent.indexOf("android") > -1) {
					this.isAndroid = true;
				} else if (userAgent.indexOf("opera") > -1) {
					this.isOpera = true;
				} else if (userAgent.indexOf("chrome") > -1) {
					this.isChrome = true;
				} else if (userAgent.indexOf("safari") > -1) {
					this.isSafari = true;
				}
	
				if (userAgent.indexOf("mac") > -1) {
					this.isMac = true;
				} else if (userAgent.indexOf("win") > -1) {
					this.isWindows = true;
				}
	
				this.isSp = this.isiPhone || this.isiPod || this.isAndroid;
			}
		}, {
			key: 'addResizeHandler',
			value: function addResizeHandler(func, scope) {
				if (typeof func == 'function') {
					this.resizeFunction.push({ fn: func, scope: scope });
				}
			}
		}, {
			key: 'removeResizeHandler',
			value: function removeResizeHandler(func) {
				if (typeof func == 'function') {
					for (var i = 0; i <= this.resizeFunction.length - 1; i++) {
						var f = this.resizeFunction[i].fn;
						if (f == func) {
							this.resizeFunction.splice(i, 1);
						}
					}
				}
			}
		}, {
			key: 'addResponsiveHandler',
			value: function addResponsiveHandler(func, scope) {
				if (typeof func == 'function') {
					this.responsiveFunction.push({ fn: func, scope: scope });
				}
			}
		}, {
			key: 'removeResponsiveHandler',
			value: function removeResponsiveHandler(func) {
				if (typeof func == 'function') {
					for (var i = 0; i <= this.responsiveFunction.length - 1; i++) {
						var f = this.responsiveFunction[i].fn;
						if (f == func) {
							this.responsiveFunction.splice(i, 1);
						}
					}
				}
			}
		}, {
			key: 'addResponsivePCSPHandler',
			value: function addResponsivePCSPHandler(func, scope) {
				if (typeof func == 'function') {
					this.responsivePCSPFunction.push({ fn: func, scope: scope });
				}
			}
		}, {
			key: 'removeResponsivePCSPHandler',
			value: function removeResponsivePCSPHandler(func) {
				if (typeof func == 'function') {
					for (var i = 0; i <= this.responsivePCSPFunction.length - 1; i++) {
						var f = this.responsivePCSPFunction[i].fn;
						if (f == func) {
							this.responsivePCSPFunction.splice(i, 1);
						}
					}
				}
			}
		}, {
			key: 'addScrollHandler',
			value: function addScrollHandler(func, scope) {
				if (typeof func == 'function') {
					this.scrollFunction.push({ fn: func, scope: scope });
				}
			}
		}, {
			key: 'removeScrollHandler',
			value: function removeScrollHandler(func) {
				if (typeof func == 'function') {
					for (var i = 0; i <= this.scrollFunction.length - 1; i++) {
						var f = this.scrollFunction[i].fn;
						if (f == func) {
							this.scrollFunction.splice(i, 1);
						}
					}
				}
			}
		}, {
			key: 'resize',
			value: function resize() {
				this._resizeHandler();
			}
		}, {
			key: 'setViewportiPad',
			value: function setViewportiPad() {
				if (!this.isiPad) return;
				var metalist = document.getElementsByTagName('meta');
				for (var i = 0; i < metalist.length; i++) {
					var name = metalist[i].getAttribute('name');
					if (name && name.toLowerCase() === 'viewport') {
						metalist[i].setAttribute('content', 'width=1150,user-scalable=no');
						break;
					}
				}
				this.resize();
			}
	
			//----------------------------------------
			//PRIVATE METHOD
			//----------------------------------------
	
		}, {
			key: '_getScrollPosition',
			value: function _getScrollPosition() {
				var obj = new Object();
				obj.x = document.documentElement.scrollLeft || document.body.scrollLeft;
				obj.y = document.documentElement.scrollTop || document.body.scrollTop;
				return obj;
			}
		}, {
			key: '_getScreenSize',
			value: function _getScreenSize() {
				var obj = new Object();
				if (!this.isSafari && !this.isOpera) {
					obj.width = document.documentElement.clientWidth || document.body.clientWidth || document.body.scrollWidth;
					obj.height = document.documentElement.clientHeight || document.body.clientHeight || document.body.scrollHeight;
				} else {
					obj.width = window.innerWidth;
					obj.height = window.innerHeight;
				}
				obj.widthHalf = parseInt(obj.width / 2);
				obj.heightHalf = parseInt(obj.height / 2);
				return obj;
			}
		}, {
			key: '_getDocumentSize',
			value: function _getDocumentSize() {
				var obj = new Object();
				obj.width = document.documentElement.scrollWidth || document.body.scrollWidth;
				obj.height = document.documentElement.scrollHeight || document.body.scrollHeight;
				return obj;
			}
		}, {
			key: '_resizeHandler',
			value: function _resizeHandler() {
				var screenSize = this._getScreenSize();
				this.windowWidth = screenSize.width;
				this.windowHeight = screenSize.height;
				this.windowWidthHalf = screenSize.widthHalf;
				this.windowHeightHalf = screenSize.heightHalf;
				var documentSize = this._getDocumentSize();
				this.documentWidth = documentSize.width;
				this.documentHeight = documentSize.height;
	
				for (var i = 0; i < this.resizeFunction.length; i++) {
					this.resizeFunction[i].fn.apply(this.resizeFunction[i].scope);
				}
	
				//PC TB SP
				if (window.matchMedia && window.matchMedia('(max-width:' + this.SP_MAX_WIDTH + 'px)').matches) {
					if (this.responsive != 'sp') {
						this.responsive = 'sp';
						for (var i = 0; i < this.responsiveFunction.length; i++) {
							this.responsiveFunction[i].fn.apply(this.responsiveFunction[i].scope);
						}
					}
				} else if (window.matchMedia && window.matchMedia('(min-width: ' + this.TB_MIN_WIDTH + 'px) and (max-width: ' + this.TB_MAX_WIDTH + 'px)').matches) {
					if (this.responsive != 'tb') {
						this.responsive = 'tb';
						for (var i = 0; i < this.responsiveFunction.length; i++) {
							this.responsiveFunction[i].fn.apply(this.responsiveFunction[i].scope);
						}
					}
				} else {
					if (this.responsive != 'pc') {
						this.responsive = 'pc';
						for (var i = 0; i < this.responsiveFunction.length; i++) {
							this.responsiveFunction[i].fn.apply(this.responsiveFunction[i].scope);
						}
					}
				}
	
				//PC SP
				if (window.matchMedia && window.matchMedia('(max-width:' + this.SP_MAX_WIDTH + 'px)').matches) {
					if (this.responsivePCSP != 'sp') {
						this.responsivePCSP = 'sp';
						for (var i = 0; i < this.responsivePCSPFunction.length; i++) {
							this.responsivePCSPFunction[i].fn.apply(this.responsivePCSPFunction[i].scope);
						}
					}
				} else {
					if (this.responsivePCSP != 'pc') {
						this.responsivePCSP = 'pc';
						for (var i = 0; i < this.responsivePCSPFunction.length; i++) {
							this.responsivePCSPFunction[i].fn.apply(this.responsivePCSPFunction[i].scope);
						}
					}
				}
			}
		}, {
			key: '_scrollHandler',
			value: function _scrollHandler() {
				var scrollPosition = this._getScrollPosition();
				this.scrollX = scrollPosition.x;
				this.scrollY = scrollPosition.y;
				this.scrollYPercent = this.windowWidth != 0 ? this.scrollY / this.windowWidth : 0;
				this.scrollRate = this.scrollY / (this.documentHeight - this.windowHeight);
				for (var i = 0; i < this.scrollFunction.length; i++) {
					this.scrollFunction[i].fn.apply(this.scrollFunction[i].scope);
				}
			}
		}]);
	
		return Browser;
	}();
	
	exports.default = new Browser();

/***/ },
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter2
	 * https://github.com/hij1nx/EventEmitter2
	 *
	 * Copyright (c) 2013 hij1nx
	 * Licensed under the MIT license.
	 */
	;!function(undefined) {
	
	  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
	    return Object.prototype.toString.call(obj) === "[object Array]";
	  };
	  var defaultMaxListeners = 10;
	
	  function init() {
	    this._events = {};
	    if (this._conf) {
	      configure.call(this, this._conf);
	    }
	  }
	
	  function configure(conf) {
	    if (conf) {
	      this._conf = conf;
	
	      conf.delimiter && (this.delimiter = conf.delimiter);
	      this._events.maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
	      conf.wildcard && (this.wildcard = conf.wildcard);
	      conf.newListener && (this.newListener = conf.newListener);
	      conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
	
	      if (this.wildcard) {
	        this.listenerTree = {};
	      }
	    } else {
	      this._events.maxListeners = defaultMaxListeners;
	    }
	  }
	
	  function logPossibleMemoryLeak(count, eventName) {
	    var errorMsg = '(node) warning: possible EventEmitter memory ' +
	        'leak detected. %d listeners added. ' +
	        'Use emitter.setMaxListeners() to increase limit.';
	
	    if(this.verboseMemoryLeak){
	      errorMsg += ' Event name: %s.';
	      console.error(errorMsg, count, eventName);
	    } else {
	      console.error(errorMsg, count);
	    }
	
	    if (console.trace){
	      console.trace();
	    }
	  }
	
	  function EventEmitter(conf) {
	    this._events = {};
	    this.newListener = false;
	    this.verboseMemoryLeak = false;
	    configure.call(this, conf);
	  }
	  EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
	
	  //
	  // Attention, function return type now is array, always !
	  // It has zero elements if no any matches found and one or more
	  // elements (leafs) if there are matches
	  //
	  function searchListenerTree(handlers, type, tree, i) {
	    if (!tree) {
	      return [];
	    }
	    var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
	        typeLength = type.length, currentType = type[i], nextType = type[i+1];
	    if (i === typeLength && tree._listeners) {
	      //
	      // If at the end of the event(s) list and the tree has listeners
	      // invoke those listeners.
	      //
	      if (typeof tree._listeners === 'function') {
	        handlers && handlers.push(tree._listeners);
	        return [tree];
	      } else {
	        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
	          handlers && handlers.push(tree._listeners[leaf]);
	        }
	        return [tree];
	      }
	    }
	
	    if ((currentType === '*' || currentType === '**') || tree[currentType]) {
	      //
	      // If the event emitted is '*' at this part
	      // or there is a concrete match at this patch
	      //
	      if (currentType === '*') {
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
	          }
	        }
	        return listeners;
	      } else if(currentType === '**') {
	        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
	        if(endReached && tree._listeners) {
	          // The next element has a _listeners, add it to the handlers.
	          listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
	        }
	
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            if(branch === '*' || branch === '**') {
	              if(tree[branch]._listeners && !endReached) {
	                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
	              }
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            } else if(branch === nextType) {
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
	            } else {
	              // No match on this one, shift into the tree but not in the type array.
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            }
	          }
	        }
	        return listeners;
	      }
	
	      listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
	    }
	
	    xTree = tree['*'];
	    if (xTree) {
	      //
	      // If the listener tree will allow any match for this part,
	      // then recursively explore all branches of the tree
	      //
	      searchListenerTree(handlers, type, xTree, i+1);
	    }
	
	    xxTree = tree['**'];
	    if(xxTree) {
	      if(i < typeLength) {
	        if(xxTree._listeners) {
	          // If we have a listener on a '**', it will catch all, so add its handler.
	          searchListenerTree(handlers, type, xxTree, typeLength);
	        }
	
	        // Build arrays of matching next branches and others.
	        for(branch in xxTree) {
	          if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
	            if(branch === nextType) {
	              // We know the next element will match, so jump twice.
	              searchListenerTree(handlers, type, xxTree[branch], i+2);
	            } else if(branch === currentType) {
	              // Current node matches, move into the tree.
	              searchListenerTree(handlers, type, xxTree[branch], i+1);
	            } else {
	              isolatedBranch = {};
	              isolatedBranch[branch] = xxTree[branch];
	              searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
	            }
	          }
	        }
	      } else if(xxTree._listeners) {
	        // We have reached the end and still on a '**'
	        searchListenerTree(handlers, type, xxTree, typeLength);
	      } else if(xxTree['*'] && xxTree['*']._listeners) {
	        searchListenerTree(handlers, type, xxTree['*'], typeLength);
	      }
	    }
	
	    return listeners;
	  }
	
	  function growListenerTree(type, listener) {
	
	    type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	
	    //
	    // Looks for two consecutive '**', if so, don't add the event at all.
	    //
	    for(var i = 0, len = type.length; i+1 < len; i++) {
	      if(type[i] === '**' && type[i+1] === '**') {
	        return;
	      }
	    }
	
	    var tree = this.listenerTree;
	    var name = type.shift();
	
	    while (name !== undefined) {
	
	      if (!tree[name]) {
	        tree[name] = {};
	      }
	
	      tree = tree[name];
	
	      if (type.length === 0) {
	
	        if (!tree._listeners) {
	          tree._listeners = listener;
	        }
	        else {
	          if (typeof tree._listeners === 'function') {
	            tree._listeners = [tree._listeners];
	          }
	
	          tree._listeners.push(listener);
	
	          if (
	            !tree._listeners.warned &&
	            this._events.maxListeners > 0 &&
	            tree._listeners.length > this._events.maxListeners
	          ) {
	            tree._listeners.warned = true;
	            logPossibleMemoryLeak.call(this, tree._listeners.length, name);
	          }
	        }
	        return true;
	      }
	      name = type.shift();
	    }
	    return true;
	  }
	
	  // By default EventEmitters will print a warning if more than
	  // 10 listeners are added to it. This is a useful default which
	  // helps finding memory leaks.
	  //
	  // Obviously not all Emitters should be limited to 10. This function allows
	  // that to be increased. Set to zero for unlimited.
	
	  EventEmitter.prototype.delimiter = '.';
	
	  EventEmitter.prototype.setMaxListeners = function(n) {
	    if (n !== undefined) {
	      this._events || init.call(this);
	      this._events.maxListeners = n;
	      if (!this._conf) this._conf = {};
	      this._conf.maxListeners = n;
	    }
	  };
	
	  EventEmitter.prototype.event = '';
	
	  EventEmitter.prototype.once = function(event, fn) {
	    this.many(event, 1, fn);
	    return this;
	  };
	
	  EventEmitter.prototype.many = function(event, ttl, fn) {
	    var self = this;
	
	    if (typeof fn !== 'function') {
	      throw new Error('many only accepts instances of Function');
	    }
	
	    function listener() {
	      if (--ttl === 0) {
	        self.off(event, listener);
	      }
	      fn.apply(this, arguments);
	    }
	
	    listener._origin = fn;
	
	    this.on(event, listener);
	
	    return self;
	  };
	
	  EventEmitter.prototype.emit = function() {
	
	    this._events || init.call(this);
	
	    var type = arguments[0];
	
	    if (type === 'newListener' && !this.newListener) {
	      if (!this._events.newListener) {
	        return false;
	      }
	    }
	
	    var al = arguments.length;
	    var args,l,i,j;
	    var handler;
	
	    if (this._all && this._all.length) {
	      handler = this._all.slice();
	      if (al > 3) {
	        args = new Array(al);
	        for (j = 0; j < al; j++) args[j] = arguments[j];
	      }
	
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this, type);
	          break;
	        case 2:
	          handler[i].call(this, type, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, type, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, args);
	        }
	      }
	    }
	
	    if (this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    } else {
	      handler = this._events[type];
	      if (typeof handler === 'function') {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler.call(this);
	          break;
	        case 2:
	          handler.call(this, arguments[1]);
	          break;
	        case 3:
	          handler.call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          args = new Array(al - 1);
	          for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	          handler.apply(this, args);
	        }
	        return true;
	      } else if (handler) {
	        // need to make copy of handlers because list can change in the middle
	        // of emit call
	        handler = handler.slice();
	      }
	    }
	
	    if (handler && handler.length) {
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this);
	          break;
	        case 2:
	          handler[i].call(this, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, args);
	        }
	      }
	      return true;
	    } else if (!this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        throw arguments[1]; // Unhandled 'error' event
	      } else {
	        throw new Error("Uncaught, unspecified 'error' event.");
	      }
	      return false;
	    }
	
	    return !!this._all;
	  };
	
	  EventEmitter.prototype.emitAsync = function() {
	
	    this._events || init.call(this);
	
	    var type = arguments[0];
	
	    if (type === 'newListener' && !this.newListener) {
	        if (!this._events.newListener) { return Promise.resolve([false]); }
	    }
	
	    var promises= [];
	
	    var al = arguments.length;
	    var args,l,i,j;
	    var handler;
	
	    if (this._all) {
	      if (al > 3) {
	        args = new Array(al);
	        for (j = 1; j < al; j++) args[j] = arguments[j];
	      }
	      for (i = 0, l = this._all.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(this._all[i].call(this, type));
	          break;
	        case 2:
	          promises.push(this._all[i].call(this, type, arguments[1]));
	          break;
	        case 3:
	          promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(this._all[i].apply(this, args));
	        }
	      }
	    }
	
	    if (this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    } else {
	      handler = this._events[type];
	    }
	
	    if (typeof handler === 'function') {
	      this.event = type;
	      switch (al) {
	      case 1:
	        promises.push(handler.call(this));
	        break;
	      case 2:
	        promises.push(handler.call(this, arguments[1]));
	        break;
	      case 3:
	        promises.push(handler.call(this, arguments[1], arguments[2]));
	        break;
	      default:
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	        promises.push(handler.apply(this, args));
	      }
	    } else if (handler && handler.length) {
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(handler[i].call(this));
	          break;
	        case 2:
	          promises.push(handler[i].call(this, arguments[1]));
	          break;
	        case 3:
	          promises.push(handler[i].call(this, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(handler[i].apply(this, args));
	        }
	      }
	    } else if (!this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        return Promise.reject(arguments[1]); // Unhandled 'error' event
	      } else {
	        return Promise.reject("Uncaught, unspecified 'error' event.");
	      }
	    }
	
	    return Promise.all(promises);
	  };
	
	  EventEmitter.prototype.on = function(type, listener) {
	    if (typeof type === 'function') {
	      this.onAny(type);
	      return this;
	    }
	
	    if (typeof listener !== 'function') {
	      throw new Error('on only accepts instances of Function');
	    }
	    this._events || init.call(this);
	
	    // To avoid recursion in the case that type == "newListeners"! Before
	    // adding it to the listeners, first emit "newListeners".
	    this.emit('newListener', type, listener);
	
	    if (this.wildcard) {
	      growListenerTree.call(this, type, listener);
	      return this;
	    }
	
	    if (!this._events[type]) {
	      // Optimize the case of one listener. Don't need the extra array object.
	      this._events[type] = listener;
	    }
	    else {
	      if (typeof this._events[type] === 'function') {
	        // Change to array.
	        this._events[type] = [this._events[type]];
	      }
	
	      // If we've already got an array, just append.
	      this._events[type].push(listener);
	
	      // Check for listener leak
	      if (
	        !this._events[type].warned &&
	        this._events.maxListeners > 0 &&
	        this._events[type].length > this._events.maxListeners
	      ) {
	        this._events[type].warned = true;
	        logPossibleMemoryLeak.call(this, this._events[type].length, type);
	      }
	    }
	
	    return this;
	  };
	
	  EventEmitter.prototype.onAny = function(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('onAny only accepts instances of Function');
	    }
	
	    if (!this._all) {
	      this._all = [];
	    }
	
	    // Add the function to the event listener collection.
	    this._all.push(fn);
	    return this;
	  };
	
	  EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	  EventEmitter.prototype.off = function(type, listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('removeListener only takes instances of Function');
	    }
	
	    var handlers,leafs=[];
	
	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	    }
	    else {
	      // does not use listeners(), so no side effect of creating _events[type]
	      if (!this._events[type]) return this;
	      handlers = this._events[type];
	      leafs.push({_listeners:handlers});
	    }
	
	    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	      var leaf = leafs[iLeaf];
	      handlers = leaf._listeners;
	      if (isArray(handlers)) {
	
	        var position = -1;
	
	        for (var i = 0, length = handlers.length; i < length; i++) {
	          if (handlers[i] === listener ||
	            (handlers[i].listener && handlers[i].listener === listener) ||
	            (handlers[i]._origin && handlers[i]._origin === listener)) {
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0) {
	          continue;
	        }
	
	        if(this.wildcard) {
	          leaf._listeners.splice(position, 1);
	        }
	        else {
	          this._events[type].splice(position, 1);
	        }
	
	        if (handlers.length === 0) {
	          if(this.wildcard) {
	            delete leaf._listeners;
	          }
	          else {
	            delete this._events[type];
	          }
	        }
	
	        this.emit("removeListener", type, listener);
	
	        return this;
	      }
	      else if (handlers === listener ||
	        (handlers.listener && handlers.listener === listener) ||
	        (handlers._origin && handlers._origin === listener)) {
	        if(this.wildcard) {
	          delete leaf._listeners;
	        }
	        else {
	          delete this._events[type];
	        }
	
	        this.emit("removeListener", type, listener);
	      }
	    }
	
	    function recursivelyGarbageCollect(root) {
	      if (root === undefined) {
	        return;
	      }
	      var keys = Object.keys(root);
	      for (var i in keys) {
	        var key = keys[i];
	        var obj = root[key];
	        if ((obj instanceof Function) || (typeof obj !== "object") || (obj === null))
	          continue;
	        if (Object.keys(obj).length > 0) {
	          recursivelyGarbageCollect(root[key]);
	        }
	        if (Object.keys(obj).length === 0) {
	          delete root[key];
	        }
	      }
	    }
	    recursivelyGarbageCollect(this.listenerTree);
	
	    return this;
	  };
	
	  EventEmitter.prototype.offAny = function(fn) {
	    var i = 0, l = 0, fns;
	    if (fn && this._all && this._all.length > 0) {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++) {
	        if(fn === fns[i]) {
	          fns.splice(i, 1);
	          this.emit("removeListenerAny", fn);
	          return this;
	        }
	      }
	    } else {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++)
	        this.emit("removeListenerAny", fns[i]);
	      this._all = [];
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
	
	  EventEmitter.prototype.removeAllListeners = function(type) {
	    if (arguments.length === 0) {
	      !this._events || init.call(this);
	      return this;
	    }
	
	    if (this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	
	      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	        var leaf = leafs[iLeaf];
	        leaf._listeners = null;
	      }
	    }
	    else if (this._events) {
	      this._events[type] = null;
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.listeners = function(type) {
	    if (this.wildcard) {
	      var handlers = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
	      return handlers;
	    }
	
	    this._events || init.call(this);
	
	    if (!this._events[type]) this._events[type] = [];
	    if (!isArray(this._events[type])) {
	      this._events[type] = [this._events[type]];
	    }
	    return this._events[type];
	  };
	
	  EventEmitter.prototype.listenerCount = function(type) {
	    return this.listeners(type).length;
	  };
	
	  EventEmitter.prototype.listenersAny = function() {
	
	    if(this._all) {
	      return this._all;
	    }
	    else {
	      return [];
	    }
	
	  };
	
	  if (true) {
	     // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return EventEmitter;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // CommonJS
	    module.exports = EventEmitter;
	  }
	  else {
	    // Browser global.
	    window.EventEmitter2 = EventEmitter;
	  }
	}();


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _btnbase = __webpack_require__(6);
	
	var _btnbase2 = _interopRequireDefault(_btnbase);
	
	var _browser = __webpack_require__(2);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BtnHamburger = function (_BtnBase) {
		_inherits(BtnHamburger, _BtnBase);
	
		function BtnHamburger($con) {
			_classCallCheck(this, BtnHamburger);
	
			return _possibleConstructorReturn(this, (BtnHamburger.__proto__ || Object.getPrototypeOf(BtnHamburger)).call(this, $con));
		}
	
		_createClass(BtnHamburger, [{
			key: 'init',
			value: function init() {
				this.$con.empty();
				var h = '';
				h += '<span class="l1"></span>';
				h += '<span class="l2"></span>';
				h += '<span class="l3"></span>';
				this.$con.append(h);
			}
		}, {
			key: 'responsiveHandler',
			value: function responsiveHandler() {
				_get(BtnHamburger.prototype.__proto__ || Object.getPrototypeOf(BtnHamburger.prototype), 'responsiveHandler', this).call(this);
				this.clear();
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.$con.find('.l1').velocity('stop').removeAttr('style');
				this.$con.find('.l2').velocity('stop').removeAttr('style');
				this.$con.find('.l3').velocity('stop').removeAttr('style');
			}
		}, {
			key: 'over',
			value: function over() {
				_get(BtnHamburger.prototype.__proto__ || Object.getPrototypeOf(BtnHamburger.prototype), 'over', this).call(this);
				if (_browser2.default.isiPad) return;
	
				if (this.$con.hasClass('close')) {} else {
					this.$con.find('.l1').velocity('stop').velocity({ width: 12 }, { duration: 80 }).velocity({ width: 22 }, { duration: 160 });
					this.$con.find('.l2').velocity('stop').velocity({ width: 12 }, { duration: 80, delay: 80 }).velocity({ width: 22 }, { duration: 160 });
					this.$con.find('.l3').velocity('stop').velocity({ width: 8 }, { duration: 80, delay: 160 }).velocity({ width: 22 }, { duration: 160 });
				}
			}
		}, {
			key: 'out',
			value: function out() {
				_get(BtnHamburger.prototype.__proto__ || Object.getPrototypeOf(BtnHamburger.prototype), 'out', this).call(this);
				this.clear();
			}
		}, {
			key: 'open',
			value: function open() {
				this.clear();
				this.$con.addClass('close');
			}
		}, {
			key: 'close',
			value: function close() {
				this.$con.removeClass('close');
			}
		}]);
	
		return BtnHamburger;
	}(_btnbase2.default);
	
	exports.default = BtnHamburger;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventemitter = __webpack_require__(4);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _browser = __webpack_require__(2);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BtnBase = function (_EventEmitter) {
		_inherits(BtnBase, _EventEmitter);
	
		function BtnBase($con) {
			_classCallCheck(this, BtnBase);
	
			var _this = _possibleConstructorReturn(this, (BtnBase.__proto__ || Object.getPrototypeOf(BtnBase)).call(this));
	
			_this.$con = $con;
			_this.$con.data('text', _this.$con.text());
			_this.isHover = false;
			_this.init();
	
			_browser2.default.addResponsiveHandler(_this.responsiveHandler, _this);
			_this.responsiveHandler();
	
			_this.$con.on('click', _this.click.bind(_this));
			return _this;
		}
	
		_createClass(BtnBase, [{
			key: 'init',
			value: function init() {}
		}, {
			key: 'responsiveHandler',
			value: function responsiveHandler() {
				this.$con.off('.pc');
				if (_browser2.default.responsive == 'pc') {
					this.$con.on('mouseenter.pc', this.over.bind(this));
					this.$con.on('mouseleave.pc', this.out.bind(this));
				} else {}
			}
		}, {
			key: 'over',
			value: function over() {
				if (_browser2.default.isiPad) return;
				this.isHover = true;
			}
		}, {
			key: 'out',
			value: function out() {
				if (_browser2.default.isiPad) return;
				this.isHover = false;
			}
		}, {
			key: 'click',
			value: function click() {
				this.emit('click', this);
			}
		}]);
	
		return BtnBase;
	}(_eventemitter2.default);
	
	exports.default = BtnBase;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _btnbase = __webpack_require__(6);
	
	var _btnbase2 = _interopRequireDefault(_btnbase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BtnPageTop = function (_BtnBase) {
		_inherits(BtnPageTop, _BtnBase);
	
		function BtnPageTop($con) {
			_classCallCheck(this, BtnPageTop);
	
			return _possibleConstructorReturn(this, (BtnPageTop.__proto__ || Object.getPrototypeOf(BtnPageTop)).call(this, $con));
		}
	
		_createClass(BtnPageTop, [{
			key: 'init',
			value: function init() {
				this.$con.empty();
				var h = '';
				h += '<span class="l1"></span>';
				h += '<span class="l2"></span>';
				this.$con.append(h);
				this.out();
			}
		}, {
			key: 'responsiveHandler',
			value: function responsiveHandler() {
				_get(BtnPageTop.prototype.__proto__ || Object.getPrototypeOf(BtnPageTop.prototype), 'responsiveHandler', this).call(this);
				this.$con.find('.l1').velocity('stop').removeAttr('style').velocity({ rotateZ: 45, translateX: 0 }, { duration: 1 });
				this.$con.find('.l2').velocity('stop').removeAttr('style').velocity({ rotateZ: -45, translateX: 0 }, { duration: 1 });
			}
		}, {
			key: 'over',
			value: function over() {
				_get(BtnPageTop.prototype.__proto__ || Object.getPrototypeOf(BtnPageTop.prototype), 'over', this).call(this);
				this.$con.find('.l1').velocity('stop').velocity({ rotateZ: 60, translateX: -4 }, { duration: 80 });
				this.$con.find('.l2').velocity('stop').velocity({ rotateZ: -60, translateX: 4 }, { duration: 80 });
			}
		}, {
			key: 'out',
			value: function out() {
				_get(BtnPageTop.prototype.__proto__ || Object.getPrototypeOf(BtnPageTop.prototype), 'out', this).call(this);
				this.$con.find('.l1').velocity('stop').velocity({ rotateZ: 45, translateX: 0 }, { duration: 80 });
				this.$con.find('.l2').velocity('stop').velocity({ rotateZ: -45, translateX: 0 }, { duration: 80 });
			}
		}, {
			key: 'click',
			value: function click() {
				_get(BtnPageTop.prototype.__proto__ || Object.getPrototypeOf(BtnPageTop.prototype), 'click', this).call(this);
				$('html').velocity('scroll', { duration: 500, easing: "swing" });
			}
		}]);
	
		return BtnPageTop;
	}(_btnbase2.default);
	
	exports.default = BtnPageTop;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _btnbase = __webpack_require__(6);
	
	var _btnbase2 = _interopRequireDefault(_btnbase);
	
	var _browser = __webpack_require__(2);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BtnTab = function (_BtnBase) {
		_inherits(BtnTab, _BtnBase);
	
		function BtnTab($con) {
			_classCallCheck(this, BtnTab);
	
			var _this = _possibleConstructorReturn(this, (BtnTab.__proto__ || Object.getPrototypeOf(BtnTab)).call(this, $con));
	
			_this.isRender = false;
			return _this;
		}
	
		_createClass(BtnTab, [{
			key: 'init',
			value: function init() {
				this.isInit = false;
				this.isCurrent = true;
				_browser2.default.addResizeHandler(this.scrollresize, this);
				_browser2.default.addScrollHandler(this.scrollresize, this);
				this.scrollresize();
			}
		}, {
			key: 'preload',
			value: function preload() {
				var _this2 = this;
	
				if (this.isInit) return;
				this.isInit = true;
	
				this.data = BtnTab[this.$con.attr('id')];
	
				this.queue = new createjs.LoadQueue(false);
	
				this.queue.loadManifest(this.data.manifest, false);
				this.queue.addEventListener("complete", function () {
					_this2.init2();
				});
				this.queue.load();
			}
		}, {
			key: 'init2',
			value: function init2() {
				var canvasid = this.$con.find('canvas').attr('id');
				this.stage = new createjs.Stage(canvasid);
				//this.stage.enableMouseOver();
				createjs.Ticker.addEventListener("tick", this.tick.bind(this));
	
				this.stage.canvas.width = this.$con.width();
				this.stage.canvas.height = this.$con.height();
	
				//IMG
				this.img = new createjs.Bitmap(this.queue.getResult('img'));
				this.stage.addChild(this.img);
	
				//COVER
				this.cover = new createjs.Shape();
				this.stage.addChild(this.cover);
				this.cover.graphics.beginFill(createjs.Graphics.getRGB(Math.floor(this.data.bg.color.r), Math.floor(this.data.bg.color.g), Math.floor(this.data.bg.color.b)));
				this.cover.graphics.drawRect(0, 0, this.stage.canvas.width, this.stage.canvas.height);
				this.cover.alpha = 0.3;
				if (this.isCurrent) {
					this.cover.alpha = 0;
				}
	
				//BG
				this.bg = new createjs.Shape();
				this.stage.addChild(this.bg);
				this.bg.x = this.stage.canvas.width - this.data.bg.width;
				this.bgobj = {
					x: 25,
					r: Math.floor(this.data.bg.color.r),
					g: Math.floor(this.data.bg.color.g),
					b: Math.floor(this.data.bg.color.b)
				};
	
				//TXT
				this.txt = new createjs.Bitmap(this.queue.getResult('txt'));
				this.stage.addChild(this.txt);
				this.txt.x = this.data.txt.x;
				this.txt.y = this.data.txt.y;
	
				//CIRCLE
				this.circle = new createjs.Container();
				this.stage.addChild(this.circle);
				this.circle.x = this.data.circle.x;
				this.circle.y = this.data.circle.y;
				this.arrow = new createjs.Bitmap(this.queue.getResult('arrow'));
				this.arrow.filters = [new createjs.ColorFilter(0, 0, 0, 1, this.data.circle.color.r, this.data.circle.color.g, this.data.circle.color.b, 0)];
				this.arrow.cache(0, 0, 20, 20);
				this.arrow.regX = 5;
				this.arrow.regY = 6;
				this.circle.addChild(this.arrow);
				this.circle1 = new createjs.Shape();
				this.circle.addChild(this.circle1);
				this.circle2 = new createjs.Shape();
				this.circle.addChild(this.circle2);
	
				this.circle1obj = {
					angle: { start: BtnTab.Common.circle1.angle.start, end: BtnTab.Common.circle1.angle.end }
				};
				this.circle2obj = {
					angle: { start: BtnTab.Common.circle2.angle.start, end: BtnTab.Common.circle2.angle.end }
				};
			}
		}, {
			key: 'tick',
			value: function tick() {
				if (!this.isRender) return;
	
				this.bg.graphics.clear();
				this.bg.graphics.beginFill(createjs.Graphics.getRGB(Math.floor(this.bgobj.r), Math.floor(this.bgobj.g), Math.floor(this.bgobj.b)));
				this.bg.graphics.moveTo(0, 0);
				this.bg.graphics.lineTo(this.data.bg.width, 0);
				this.bg.graphics.lineTo(this.data.bg.width, this.data.bg.height);
				this.bg.graphics.lineTo(0, this.data.bg.height);
				this.bg.graphics.quadraticCurveTo(this.bgobj.x, this.data.bg.height >> 1, 0, 0);
				this.bg.graphics.endFill();
	
				this.circle1.graphics.clear();
				this.circle1.graphics.setStrokeStyle(8, "round");
				if (this.isHover) {
					this.circle1.graphics.beginStroke(createjs.Graphics.getRGB(255, 255, 255));
				} else {
					this.circle1.graphics.beginStroke(createjs.Graphics.getRGB(this.data.circle.color.r, this.data.circle.color.g, this.data.circle.color.b));
				}
	
				this.circle1.graphics.arc(0, 0, 32, this.circle1obj.angle.start, this.circle1obj.angle.end);
	
				this.circle2.graphics.clear();
				this.circle2.graphics.setStrokeStyle(8, "round");
				if (this.isHover) {
					this.circle2.graphics.beginStroke(createjs.Graphics.getRGB(255, 255, 255));
				} else {
					this.circle2.graphics.beginStroke(createjs.Graphics.getRGB(this.data.circle.color.r, this.data.circle.color.g, this.data.circle.color.b));
				}
				this.circle2.graphics.arc(0, 0, 32, this.circle2obj.angle.start, this.circle2obj.angle.end);
	
				this.stage.update();
			}
		}, {
			key: 'scrollresize',
			value: function scrollresize() {
				//scroll
				if (_browser2.default.responsive == 'pc' || _browser2.default.responsive == 'tb') {
					var startY = this.$con.offset().top - _browser2.default.windowHeight;
					var endY = startY + this.$con.height() + _browser2.default.windowHeight;
					if (_browser2.default.scrollY >= startY && _browser2.default.scrollY < endY) {
						this.isRender = true;
					} else {
						this.isRender = false;
					}
				} else {
					this.isRender = false;
				}
	
				//console.log( this.$con.attr('id') , startY , endY , Browser.scrollY );
				//console.log(startY , endY , Browser.scrollY);
			}
		}, {
			key: 'responsiveHandler',
			value: function responsiveHandler() {
				_get(BtnTab.prototype.__proto__ || Object.getPrototypeOf(BtnTab.prototype), 'responsiveHandler', this).call(this);
	
				if (_browser2.default.responsive == 'pc') {
					this.preload();
					this.isRender = true;
				} else {
					this.isRender = false;
				}
			}
		}, {
			key: 'over',
			value: function over() {
				_get(BtnTab.prototype.__proto__ || Object.getPrototypeOf(BtnTab.prototype), 'over', this).call(this);
	
				this.arrow.filters = [];
				this.arrow.cache(0, 0, 20, 20);
	
				createjs.Tween.get(this.bgobj, { override: true }).to({ x: -6 }, 500, createjs.Ease.elasticOut);
				createjs.Tween.get(this.bgobj, { override: false }).to({ r: this.data.bg.color_hover.r, g: this.data.bg.color_hover.g, b: this.data.bg.color_hover.b }, 150);
				createjs.Tween.get(this.arrow, { override: false }).to({ rotation: 360 }, 150);
				createjs.Tween.get(this.circle1obj.angle, { override: false }).to({
					start: BtnTab.Common.circle1.angle_hover.start,
					end: BtnTab.Common.circle1.angle_hover.end
				}, 400, createjs.Ease.backOut);
				createjs.Tween.get(this.circle2obj.angle, { override: false }).to({
					start: BtnTab.Common.circle2.angle_hover.start,
					end: BtnTab.Common.circle2.angle_hover.end
				}, 400, createjs.Ease.backOut);
	
				createjs.Tween.get(this.cover, { override: true }).to({ alpha: 0 }, 100);
			}
		}, {
			key: 'out',
			value: function out() {
				_get(BtnTab.prototype.__proto__ || Object.getPrototypeOf(BtnTab.prototype), 'out', this).call(this);
	
				this.arrow.filters = [new createjs.ColorFilter(0, 0, 0, 1, this.data.circle.color.r, this.data.circle.color.g, this.data.circle.color.b, 0)];
				this.arrow.cache(0, 0, 20, 20);
	
				createjs.Tween.get(this.bgobj, { override: true }).to({ x: 25, r: this.data.bg.color.r, g: this.data.bg.color.g, b: this.data.bg.color.b }, 500, createjs.Ease.quintOut);
				createjs.Tween.get(this.arrow, { override: false }).to({ rotation: 0 }, 150);
				createjs.Tween.get(this.circle1obj.angle, { override: false }).to({
					start: BtnTab.Common.circle1.angle.start,
					end: BtnTab.Common.circle1.angle.end
				}, 300, createjs.Ease.quintOut);
				createjs.Tween.get(this.circle2obj.angle, { override: false }).to({
					start: BtnTab.Common.circle2.angle.start,
					end: BtnTab.Common.circle2.angle.end
				}, 300, createjs.Ease.quintOut);
	
				if (this.isCurrent) {
					createjs.Tween.get(this.cover, { override: true }).to({ alpha: 0 }, 150);
				} else {
					createjs.Tween.get(this.cover, { override: true }).to({ alpha: 0.3 }, 150);
				}
			}
		}, {
			key: 'click',
			value: function click() {
				_get(BtnTab.prototype.__proto__ || Object.getPrototypeOf(BtnTab.prototype), 'click', this).call(this);
			}
		}, {
			key: 'current',
			value: function current(bool) {
				this.isCurrent = bool;
			}
		}]);
	
		return BtnTab;
	}(_btnbase2.default);
	
	BtnTab.Common = {
		circle1: {
			angle: { start: 0, end: Math.PI * 1.5 },
			angle_hover: { start: Math.PI * 0.63, end: Math.PI * 0.87 }
		},
		circle2: {
			angle: { start: Math.PI * 1.63, end: Math.PI * 1.87 },
			angle_hover: { start: Math.PI * 1.0, end: Math.PI * 2.5 }
		}
	};
	BtnTab.BtnSanpo = {
		manifest: [{ "src": "./img/top/tabbtn/arrow_bottom.png", "id": "arrow" }, { "src": "./img/top/tabbtn/btn_img_sanpo.png", "id": "img" }, { "src": "./img/top/tabbtn/btn_txt_sanpo.png", "id": "txt" }],
		bg: {
			color: { r: 77, g: 105, b: 197 },
			color_hover: { r: 104, g: 131, b: 222 },
			width: 240,
			height: 248
		},
		txt: {
			x: 322,
			y: 27
		},
		circle: {
			x: 406,
			y: 154,
			color: { r: 204, g: 198, b: 201 }
		}
	};
	BtnTab.BtnZoom = {
		manifest: [{ "src": "./img/top/tabbtn/arrow_bottom.png", "id": "arrow" }, { "src": "./img/top/tabbtn/btn_img_zoom.png", "id": "img" }, { "src": "./img/top/tabbtn/btn_txt_zoom.png", "id": "txt" }],
		bg: {
			color: { r: 57, g: 63, b: 75 },
			color_hover: { r: 75, g: 86, b: 108 },
			width: 240,
			height: 248
		},
		txt: {
			x: 322,
			y: 27
		},
		circle: {
			x: 406,
			y: 154,
			color: { r: 224, g: 229, b: 165 }
		}
	};
	BtnTab.BtnZoomBottom = {
		manifest: [{ "src": "./img/top/tabbtn/arrow_right.png", "id": "arrow" }, { "src": "./img/top/tabbtn/btn_img_zoom_bottom.png", "id": "img" }, { "src": "./img/top/tabbtn/btn_txt_zoom_bottom.png", "id": "txt" }],
		bg: {
			color: { r: 57, g: 63, b: 75 },
			color_hover: { r: 75, g: 86, b: 108 },
			width: 540,
			height: 219
		},
		txt: {
			x: 441,
			y: 70
		},
		circle: {
			x: 838,
			y: 110,
			color: { r: 224, g: 229, b: 165 }
		}
	};
	BtnTab.BtnSanpoBottom = {
		manifest: [{ "src": "./img/top/tabbtn/arrow_right.png", "id": "arrow" }, { "src": "./img/top/tabbtn/btn_img_sanpo_bottom.png", "id": "img" }, { "src": "./img/top/tabbtn/btn_txt_sanpo_bottom.png", "id": "txt" }],
		bg: {
			color: { r: 77, g: 105, b: 197 },
			color_hover: { r: 104, g: 131, b: 222 },
			width: 540,
			height: 219
		},
		txt: {
			x: 441,
			y: 70
		},
		circle: {
			x: 838,
			y: 110,
			color: { r: 204, g: 198, b: 201 }
		}
	};
	
	exports.default = BtnTab;

/***/ },
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventemitter = __webpack_require__(4);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _browser = __webpack_require__(2);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gnav = function (_EventEmitter) {
		_inherits(Gnav, _EventEmitter);
	
		function Gnav($con) {
			_classCallCheck(this, Gnav);
	
			var _this = _possibleConstructorReturn(this, (Gnav.__proto__ || Object.getPrototypeOf(Gnav)).call(this));
	
			_this.$con = $con;
			_this.isOpen = false;
	
			_this.$con.find('.sanpo').on('click', function () {
				_this.navClick('TabSanpo');
			});
			_this.$con.find('.zoom').on('click', function () {
				_this.navClick('TabZoom');
			});
			return _this;
		}
	
		_createClass(Gnav, [{
			key: 'open',
			value: function open() {
				this.isOpen = true;
				this.$con.show();
	
				if (_browser2.default.responsive == 'sp') {
					this.$con.velocity('stop').velocity({ translateY: [0, '-100%'] }, { duration: 400, easing: 'swing' });
				} else {
					this.$con.find('.li1').velocity('stop').velocity({ translateX: [0, '-100%'] }, { duration: 400, easing: 'swing' });
					this.$con.find('.li2').velocity('stop').velocity({ translateX: [0, '100%'] }, { duration: 400, easing: 'swing' });
				}
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.$con.velocity('stop').removeAttr('style');
				this.$con.find('.li1').velocity('stop').removeAttr('style');
				this.$con.find('.li2').velocity('stop').removeAttr('style');
			}
		}, {
			key: 'close',
			value: function close() {
				var _this2 = this;
	
				this.isOpen = false;
	
				if (_browser2.default.responsive == 'sp') {
					this.$con.velocity('stop').velocity({ translateY: '-100%' }, { duration: 400, easing: 'swing',
						complete: function complete() {
							_this2.$con.hide();
							_this2.clear();
						}
					});
				} else {
					this.$con.find('.li1').velocity('stop').velocity({ translateX: '-100%' }, { duration: 400, easing: 'swing' });
					this.$con.find('.li2').velocity('stop').velocity({ translateX: '100%' }, { duration: 400, easing: 'swing',
						complete: function complete() {
							_this2.$con.hide();
							_this2.clear();
						}
					});
				}
			}
		}, {
			key: 'navClick',
			value: function navClick(id) {
				this.emit('nav_click', id);
			}
		}]);
	
		return Gnav;
	}(_eventemitter2.default);
	
	exports.default = Gnav;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// js/spot.js